import { render, staticRenderFns } from "./OrdersBoxesPopup.vue?vue&type=template&id=3bf7e844&scoped=true&"
import script from "./OrdersBoxesPopup.vue?vue&type=script&lang=js&"
export * from "./OrdersBoxesPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersBoxesPopup.vue?vue&type=style&index=0&id=3bf7e844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7e844",
  null
  
)

export default component.exports